import { render, staticRenderFns } from "./TripWall.vue?vue&type=template&id=1c24c644&scoped=true&"
import script from "./TripWall.vue?vue&type=script&lang=js&"
export * from "./TripWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24c644",
  null
  
)

export default component.exports